import { render, staticRenderFns } from "./DialogDetailMining.vue?vue&type=template&id=06940a3c"
import script from "./DialogDetailMining.vue?vue&type=script&lang=js"
export * from "./DialogDetailMining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports